import React from "react";
import { Link } from "react-router-dom";
// import localSliderImg4 from "../../../../assets/image/story-slider-img-4.webp";
import { getImageUrl } from "../../../../api/leads";
const StoryCard = ({ item }: any) => {
  const { localstories, photo } = item;
  const headerImage = photo[1].photo;
  // {[1, 14].includes(localstories.id)
  //   ? localstories.subtitle
  //   : localstories.title}

  return (
    <Link replace
      key={localstories.id}
      to={`local/${localstories.storyname}`}
      className="slider-img-container"
    >
      <img
        src={getImageUrl(localstories.foldername, headerImage)}
        // src={localSliderImg4}
        alt={localstories.title}
        height={"400px"}
      />
      <div className="story-img-content">
        <h1 className="main-heading">
          {localstories.subtitle}
        </h1>
        <span className="read-more-link">READ MORE</span>
      </div>
    </Link>
  );
};

export default StoryCard;
